// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';

function textOf(blob) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsText(blob);
    });
}

function parsedIfJson(text) {
    try {
        return JSON.parse(text);
    } catch (notJson) {
        return text;
    }
}

async function withItsBodyReadable(failure) {
    const { response } = failure;

    if (response && response.data instanceof Blob) {
        response.data = parsedIfJson(await textOf(response.data));
    }

    return failure;
}

const actions = {
    getAllHours: ({commit}, payload) => {
        const { ApiClient, department, year, week, format } = payload;

        const params =  {
          firebaseIdToken: ApiClient.token,
          ...(format ? { format } : {}),
          ...(department ? { department } : {}),
        };

        // For binary formats (like xls), we need to set responseType to 'blob'
        const config = {
          params
        };
        
        if (format === 'xls') {
          config.responseType = 'blob';
        }
        
        return axios.get(
            process.env.VUE_APP_HOUR_APP_BACKEND + '/api/hours?year=' + year + '&week=' + week,
            config
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    exportOpenHours: (context, payload) => {
        const { ApiClient, department, year, week, format } = payload;

        return axios.post(
            process.env.VUE_APP_HOUR_APP_BACKEND + '/api/hours/export',
            {
              year,
              week,
              format,
              ...(department ? { department } : {}),
            },
            {
              params: { firebaseIdToken: ApiClient.token },
              ...(format === 'xls' ? { responseType: 'blob' } : {}),
            }
          ).then(res => {
            return res
          }).catch(withItsBodyReadable);
    },
    getRoster: (context, payload) => {
        const { ApiClient, department, year, week } = payload;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/hours/roster', {
            params: {
              firebaseIdToken: ApiClient.token,
              year,
              week,
              ...(department ? { department } : {}),
            }
          }).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    createHours: ({commit}, payload) => {
      const ApiClient = payload.ApiClient;
      const departments = payload.departments;
      const body = payload.body;

      return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/hours', 
        body,
        {
          params: {
              firebaseIdToken: ApiClient.token,
              departments: departments,
          }
        }
      ).then(res => {
          return res
      }).catch((err) => {
          return err
      });
    },
    createHoursCSV: ({commit}, payload) => {
      const ApiClient = payload.ApiClient;
      const departments = payload.departments;
      const file = payload.file;

      const formData = new FormData();
      formData.append('hours', file);

      return axios.post(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/hours/file', 
        formData,
        {
          params: {
              firebaseIdToken: ApiClient.token,
              departments: departments,
          }
        }
      ).then(res => {
          return res
      }).catch((err) => {
          return err
      });
    },
    updateHour: ({commit}, payload) => {
      const ApiClient = payload.ApiClient;
      const departments = payload.departments;
      
      const hourId = payload.hourId;
      const status = payload.status;
      const hours = payload.hours;
      const overtime = payload.overtime;
      const extra_payment = payload.extra_payment;
      const shift_allowance = payload.shift_allowance;
      const shift_id = payload.shift_id;

      return axios.patch(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/hour/' + hourId, 
        {
          status,
          hours,
          overtime,
          extra_payment,
          shift_allowance,
          shift_id
        },
        {
            params: {
                firebaseIdToken: ApiClient.token,
                departments: departments,
            }
        }
      ).then(res => {
          return res
      }).catch((err) => {
          return err
      });
    }
}

export default actions